import { Notification } from 'elementui-lts';
import i18n from '@/main';

export const ErrorHandler = {
    catchError(error, module) {
        const errorMessage = error.response?.data?.message || '';

        if (errorMessage.includes('This contract')) {
            const reportNumberMatch = errorMessage.match(/\((\d+)\)/);
            const reportNumber = reportNumberMatch ? reportNumberMatch[1] : '';

            Notification.error({
                message: i18n.t(`${module}.messages.errors.reportNumberExists`, { reportNumber })
            });
            return true;
        } else if (errorMessage.includes('Total informed volume of contracts')) {
            const volumeMatch = errorMessage.match(/contracts \(([\d.]+)\).*report \(([\d.]+)\)/);
            const totalContractsVolume = volumeMatch ? volumeMatch[1] : '';
            const traceabilityReportVolume = volumeMatch ? volumeMatch[2] : '';

            Notification.error({
                message: i18n.t(`${module}.messages.errors.volumeError`, {
                    totalContractsVolume,
                    traceabilityReportVolume
                })
            });
            return true;
        } else if (errorMessage.includes('The informed contract')) {
            const contractMatch = errorMessage.match(/contract \((\d+)\)/);
            const contractNumber = contractMatch ? contractMatch[1] : '';

            Notification.error({
                message: i18n.t(`${module}.messages.errors.negativeBalance`, { contractNumber })
            });
            return true;
        } else {
            return false;
        }
    }
};
